import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import "jspdf-autotable";
import { Row, Col, Container, Card, CardBody, Form } from "react-bootstrap";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import MasterService from "../../Services/MasterService";
import AlertModal from "../Alert/AlertModal";
import * as Yup from "yup";
import { Button } from "@mui/material";
import { FaKey } from "react-icons/fa";
import { CiSaveDown1 } from "react-icons/ci";
import { maskMobile } from "../utils/commonFunctions";

export default function ResetPassword() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [deptList, setDeptList] = useState([]); const [distList, setDistList] = useState([]); const [mandList, setMandList] = useState([]); const [empList, setEmpList] = useState([]); const [adminEmpList, setAdminEmpList] = useState([]);

  let username = localStorage.getItem("username"); let secretariat = localStorage.getItem("SectariatName"); let deptId = localStorage.getItem("deptid"); let distId = localStorage.getItem("districtid"); let roleId = localStorage.getItem("role");

  const formik = useFormik({
    initialValues: { usercode: "", secretariat: secretariat, deptid: deptId, distid: distId, ofcid: "", mandid: "", },
    validationSchema: Yup.object().shape({
      secretariat: Yup.string().required("Required"),
      deptid: Yup.string().required("Required"),
      ofcid: Yup.string().required("Required"),
      distid: Yup.string().required("Required"),
      mandid: Yup.string().when("ofcid", { is: (value) => value == "31", then: (schema) => schema.required("Required"), otherwise: (schema) => schema.notRequired() }),
    }),
  });

  useEffect(() => {
    let depparams = { userId: username };
    MasterService.getDeptartments(depparams).then((res) => {
      if (res.data) {
        let options = res.data.SDESC.map((item) => { return ( <option key={item.dept_id} value={item.dept_id}> {item.dept_name} </option> ); });
        setDeptList(options);
      }
    });
    MasterService.getDistricts().then((distresponse) => {
      if (distresponse.data) {
        let options = distresponse.data.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); });
        setDistList(options);
      }
    });
    if (roleId === "32"|| roleId==="2") {
      mandalData(distId);
      formik.setFieldValue("ofcid", "31");
    }else
    if (roleId == "61") {
      formik.setFieldValue("deptid", "");
    }
  }, []);

  const handleDistrict = async (dist) => {
    formik.setFieldValue("distid", dist || ""); setMandList([]); formik.setFieldValue("mandid", ""); setEmpList([]);
    if (!dist) { return; }
    const ofc = formik.values.ofcid;
    if (!ofc) { formik.setFieldTouched("ofcid", true); formik.validateField("ofcid"); return; }
    if (ofc === "32") {
      EmployeeData(formik.values.deptid, "32", dist, "0");
    } else if (ofc === "31") {
      mandalData(dist);
    } else { setMandList([]); formik.setFieldValue("mandid", ""); }
  };

  const mandalData = async (dist) => {
    let params = { district_id: dist };
    try {
      const mandres = await MasterService.getMandals(params);
      if (mandres.data) {
        let options = mandres.data.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); });
        setMandList(options);
      }
    } catch (error) {
      console.error("Error fetching mandals:", error);
    }
  };

  const EmployeeData = async (dept, ofcid, dist, mand) => {
    let emppayload = { userId: username, deptId: dept, officerID: ofcid, distId: dist, mandalId: mand };
    store.dispatch({ type: "SHOW_SPINNER" });
    try {
      const empres = roleId==="2"? await KpiService.getdeptwiseempdata(emppayload): await KpiService.getDeptWiseMappedOfficersDetails(emppayload)
      if (empres.data && empres.data?.SCODE === "01") { const filterEmp = empres.data.dataList.filter((item) => item.user_id !== "Officer Not Mapped"); setEmpList(filterEmp); } else { setEmpList([]); }
    } catch (error) {
      setEmpList([]);
      console.error("Error fetching mandals:", error);
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const AdminLevel = async (userid) => {
    if (!userid) { showAlertMessage("User Id required"); return; }
    store.dispatch({ type: "SHOW_SPINNER" });
    try {
      const empres = await KpiService.searchuser({ userId: userid });
      if (empres.data) { setAdminEmpList(empres.data); } else { setAdminEmpList([]); }
    } catch (error) {
      setAdminEmpList([]);
      console.error("Error fetching mandals:", error);
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const ResetPaswd = async (userid) => {
    let resetparam = { userId: userid };
    store.dispatch({ type: "SHOW_SPINNER" });
    try {
      const response = await KpiService.resetuserpassword(resetparam);
      if (response.data) { showAlertMessage(response.data, "success"); }
    } catch (error) {
      console.error("Error fetching mandals:", error);
    } finally {
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };


  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "85%" }}>
        <div className="sa-title"> <h2> Reset<span> Password</span> </h2> </div>
      </Container>
      <Container fluid style={{ width: "85%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Card className="mb-5 rounded-2 border" style={{ borderColor: "#ccc", boxShadow: "none" }}>
              <CardBody>
                <Row>
                  {(roleId === "8" || roleId === "5" || roleId === "62") && (
                    <>
                      <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group> <Form.Label> User Id <span className="text-danger">*</span> </Form.Label> <Field type="text" name="usercode" placeholder="Enter user Id" className={`form-control w-100 ${formik.touched.usercode && formik.errors.usercode ? "is-invalid" : ""}`} /> </Form.Group>
                      </Col>
                      <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12} className="mb-3 mt-auto"> <Button variant="contained" style={{ backgroundColor: "#fbb040", borderColor: "#fbb040", color: "black" }} type="button" onClick={() => { AdminLevel(formik.values.usercode); }} > Get Data </Button> </Col>
                    </>
                  )}

                  {(roleId !== "8" && roleId !== "5" && roleId !== "62") && (
                    <>
                      <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group>
                          <Form.Label> Secretariat Name <span className="text-danger">*</span> </Form.Label>
                          <Field type="text" name="secretariat" disabled className={`form-control w-100 ${formik.touched.secretariat && formik.errors.secretariat ? "is-invalid" : ""}`} />
                        </Form.Group>
                      </Col>
                      <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group>
                          <Form.Label> HOD Name <span className="text-danger">*</span> </Form.Label>
                          <Field as="select" name="deptid" className={`form-select ${formik.touched.deptid && formik.errors.deptid ? "is-invalid" : ""}`} disabled={roleId !== "61"}> <option value="">Select</option> {deptList} </Field>
                          <ErrorMessage name="ofcid" component="div" className="text-danger mt-2" />
                        </Form.Group>
                      </Col>

                      <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group>
                          <Form.Label> Officer Type<span className="text-danger">*</span> </Form.Label>
                          <Field as="select" name="ofcid" className={`form-select ${formik.touched.ofcid && formik.errors.ofcid ? "is-invalid" : ""}`} disabled={roleId === "32"|| roleId === "31" || roleId==="2"} onChange={(e) => { formik.setFieldValue("distid", ""); formik.setFieldValue("mandid", ""); setMandList([]); setEmpList([]); formik.handleChange(e); }} > <option value="">Select</option> <option value="32">District Officer</option> <option value="31">Mandal Officer</option> </Field>
                          <ErrorMessage name="ofcid" component="div" className="text-danger mt-2" />
                        </Form.Group>
                      </Col>

                      <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12} className="mb-3">
                        <Form.Group>
                          <Form.Label>
                            District <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            as="select"
                            name="distid"
                            className={`form-select ${formik.touched.distid && formik.errors.distid ? "is-invalid" : ""}`}
                            disabled={roleId === "32" || roleId==="2"}
                            onChange={(e) => {
                              handleDistrict(e.target.value);
                            }}
                          >
                            <option value="">Select</option>
                            {formik.values.ofcid === "32" && <option value="0">All</option>}
                            {distList}
                          </Field>
                          <ErrorMessage name="distid" component="div" className="text-danger mt-2" />
                        </Form.Group>
                      </Col>

                      {formik.values.ofcid === "31" && formik.values.distid !== "" && (
                        <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12} className="mb-3">
                          <Form.Group>
                            <Form.Label> Mandal <span className="text-danger">*</span> </Form.Label>
                            <Field as="select" name="mandid" className={`form-select ${formik.touched.mandid && formik.errors.mandid ? "is-invalid" : ""}`} onChange={(e) => { if (e.target.value !== "") { EmployeeData(formik.values.deptid, "31", formik.values.distid, e.target.value); } else { setEmpList([]); } formik.handleChange(e); }} > <option value="">Select</option> <option value="0">All</option> {mandList} </Field>
                            <ErrorMessage name="mandid" component="div" className="text-danger mt-2" />
                          </Form.Group>
                        </Col>
                      )}
                    </>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Form>
        </FormikProvider>

         {(roleId === "8"||roleId === "5" || roleId === "62" )&& (
          <div id="table-scroll" className="table-scroll">
            <div className="table-wrap">
              <table id="my-table" className="custom-table table-responsive table-striped table table-bordered">
                <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                  <tr className="text-center"> <th>Sl No.</th> <th>Cfms Id/User Id</th> <th>Designation</th> <th>District</th> <th>Mandal</th> <th>Employee Name</th> <th>Mobile</th> <th>Action</th> </tr>
                </thead>
                <tbody>
                  {adminEmpList?.length > 0 ? (
                    adminEmpList?.map((item, index) => (
                      <tr key={index} className="text-center"> <td>{index + 1}</td> <td>{item.cfmsId}/{item.userId}</td> <td>{item.designation}</td> <td>{item.distName}</td> <td>{item.mandalName}</td> <td>{item.employeeName}</td> <td>{maskMobile(item.phone)}</td> <td> <Button variant="contained" color="success" size="small" type="button" onClick={() => { ResetPaswd(item.userId); }} startIcon={<FaKey style={{ fontSize: "13px" }} />} > Reset </Button> </td> </tr>
                    ))
                  ) : (
                    <tr> <td colSpan="9" className="text-center"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}


        {(roleId !== "8" && roleId !== "5" && roleId !== "62" )&& (
          <div id="table-scroll" className="table-scroll">
            <div className="table-wrap">
              <table id="my-table" className="custom-table table-responsive table-striped table table-bordered">
                <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                  <tr className="text-center"> <th>Sl No.</th> <th>Cfms Id/User Id</th> <th>District</th> {formik.values.ofcid == "31" && <th>Mandal</th>} <th>Working Office</th> <th>Position Id</th> <th>Employee Name</th> <th>Mobile</th> <th>Action</th> </tr>
                </thead>
                <tbody>
                  {empList?.length > 0 ? (
                    empList?.map((item, index) => (
                      <tr key={index} className="text-center">
                        <td>{index + 1}</td>
                        <td>{item.user_data}</td>
                        <td>{item.district_name}</td>
                        {formik.values.ofcid == "31" && <td>{item.mandal_name}</td>}
                        <td>{item.working_office}</td>
                        <td>{item.position_id}</td>
                        <td>{item.emp_name}</td>
                        <td>{maskMobile(item.mobile_number)}</td>
                        <td>
                          <Button
                            variant="contained"
                            color="success"
                            size="small"
                            type="button"
                            onClick={() => {
                              ResetPaswd(item.user_id);
                            }}
                            startIcon={<FaKey style={{ fontSize: "13px" }} />}
                          >
                            Reset
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        <b style={{ color: "red" }}>Details Not Found</b>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}